import { useEffect, useMemo, useState } from "react";
import { useDebounce } from "./useDebounce";

// Updates, but doesn't clear the title
//
// Hooks can be hard to use conditionally. This hook
// lets you conditionally set the document title.
//
// Pass any non-empty string to set the title, and pass
// the empty string leave the title unchanged.
//
// Debounced to avoid flicker.
export function useDocumentTitle(title: string = "") {
  const stable = useDebounce(title, 30);
  const [prev, setPrev] = useState("");
  const sticky = useMemo(() => stable || prev, [stable, prev]);
  useEffect(() => {
    if (sticky && sticky !== prev) {
      document.title = sticky;
      setPrev(sticky);
    }
  }, [prev, sticky]);
}
